export default __webpack_public_path__ + "static/media/Vector.99371823.svg";